export default __webpack_public_path__ + "static/media/03.2543e1f8.jpg";